module.exports = __webpack_public_path__ + "img/AUR-alt.fb0538aa.svg";